<template>
  <el-dialog
    title="补贴"
    :model-value="dialogVisible"
    :before-close="handleClose">
    <el-table :data="subsidyList">
      <el-table-column
        property="subsidyName"
        label="补贴文件名称"
        width="200"></el-table-column>
      <el-table-column
        property="orgName"
        label="机构名称"
        width="200"></el-table-column>
      <el-table-column
        property="contact"
        label="联系人"
        width="100"></el-table-column>
      <el-table-column
        property="phone"
        label="联系电话"
        width="120"></el-table-column>
      <el-table-column
        prop="action"
        label="操作"
        align="center"
        fixed="right">
        <template #default="scope">
          <div
            class=""
            v-for="(item, index) in scope.row.attachmentList"
            :key="`${item.id}_${index}`">
            <span>文件{{ index + 1 }}</span>
            <el-button
              type="text"
              @click="handleView(item)">
              预览
            </el-button>
            <span class="action-dividing">|</span>
            <el-button
              type="text"
              @click="handleDownload(item)">
              下载
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script lang="ts" setup>
  import { computed, ref, watch } from 'vue'
  import { useGlobalStore } from '~/stores/global'
  import { fetchSubsidyListByEid } from '~/api/subsidy'

  const props = defineProps({
    dialogVisible: {
      type: Boolean,
      default: false
    },
    exhibitionId: {
      type: Number
    }
  })
  const emit = defineEmits(['update:dialogVisible'])

  const subsidyList = ref<Array<any>>([])
  const globalStore = useGlobalStore()
  const isLogin = computed(() => globalStore.isLogin)

  // 关闭对话框
  const handleClose = () => {
    emit('update:dialogVisible', false)
  }

  // 获取补贴列表
  const getSubsidyList = async () => {
    const res = await fetchSubsidyListByEid({
      exhibitionId: props.exhibitionId
    })
    if (res?.code === ResponseCode.SUCCESS) {
      subsidyList.value = res.data
    }
  }

  // 预览文件
  const handleView = (row: any) => {
    window.open(row.url)
  }

  // 下载文件
  const handleDownload = (row: any) => {
    const link = document.createElement('a')
    const fname = row.fileName // 下载文件的名字+后缀名
    link.href = row.url
    link.target = '_blank'
    link.setAttribute('download', fname)
    document.body.appendChild(link)
    link.click()
  }

  watch(
    () => props.dialogVisible,
    val => {
      if (val) {
        getSubsidyList()
      }
    },
    { immediate: true }
  )
</script>

<style lang="less" scoped>
  .subsidy_content {
    text-align: justify;

    .sub_tit {
      font-size: 18px;
      color: #333;
      line-height: 24px;
      margin-bottom: 12px;
    }

    .guide {
      margin-bottom: 24px;

      p {
        font-size: 16px;
        color: #333;
        line-height: 28px;
        margin-bottom: 5px;
      }
    }

    .guide_list {
      font-size: 16px;
      color: #333;
      line-height: 28px;
      margin-bottom: 30px;
    }

    .content {
      font-size: 16px;
      color: #333;
      line-height: 28px;
      margin-bottom: 30px;
    }
  }
</style>
